import React, {useState} from 'react'
import Carousel from 'react-multi-carousel';
import {responsive} from '../constants/responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { Image } from 'react-bootstrap';
import { base_url } from '../../../Api/ApiConst';
import { getStyles } from '../ViewProduct.style';
import { ProductCarouselProps } from '../types/view_product';
const ProductCarousel = ({ productImage, additionalImages, activeIndex, setActiveIndex, handleThumbnailClick }: ProductCarouselProps) => {
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const styles = getStyles(isMobile)

      const renderCarouselItems = () => {
    const images = [
      productImage,
      ...additionalImages
    ].filter((image) => image); 


    return images.map((image, index) => {
    return (
      <div key={index} style={{ width: 300, height: 300, margin: "auto" }}>
        <Image
          src={base_url.concat(image)}
          alt={`Product Image ${index + 1}`}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    )
    }
  );
  };
  const renderThumbnails = () => {
    const images = [
      productImage,
      ...additionalImages
    ].filter((image) => image); // Filter out empty image URLs

    return images.map((image, index) => (
      <div key={index} className="thumbnail">
        <Image
          src={base_url.concat(image) }
          alt={`Thumbnail Image ${index + 1}`}
          style={{
            cursor: "pointer",
            border: activeIndex === index ? "2px solid #808080" : "none",
          }}
          onClick={() => handleThumbnailClick(index)}
        />
      </div>
    ));
  };

  return (
    <div style={styles.productImageWrap} className="viewProductImageSlider">
    
                            <Carousel
                              responsive={responsive}
                              ssr={true}
                              itemClass="image-item"
                              customTransition="all .5"
                              transitionDuration={500}
                              containerClass="carousel-container"
                              additionalTransfrom={0}
                              showDots={false}
                              renderDotsOutside={false}
                              arrows={true}
                              infinite={false}
                              draggable={false}
                              swipeable={true}
                              autoPlay={false}
                              centerMode={false}
                              dotListClass=""
                              sliderClass=""
                              slidesToSlide={1}
                              keyBoardControl={true}
                              minimumTouchDrag={80}
                              partialVisible={false}
                              beforeChange={(nextSlide) =>
                                setActiveIndex(nextSlide)
                              }
                              customLeftArrow={
                                <div className="custom-arrow left">
                                  <FontAwesomeIcon icon={faAngleLeft as any} />
                                </div>
                              }
                              customRightArrow={
                                <div className="custom-arrow right">
                                  <FontAwesomeIcon icon={faAngleRight as any} />
                                </div>
                              }
                            >
                              {renderCarouselItems()}
                            </Carousel>
                            <div
                              className="thumbnail-container mt-3"
                              style={{ display: "flex", justifyContent: "center" }}
                            >
                              {renderThumbnails()}
                            </div>
                          </div>
  )
}

export default ProductCarousel